import { auth, invoiceBaseURL } from "../Utility";
import axios from 'axios'

// invoice
export const invoiceAxiosInstance = axios.create({
  baseURL: 'https://sales.itworkshop.in/',
  headers: { 'Content-Type': 'application/json' },
}); 

// interceptors invoice
invoiceAxiosInstance.interceptors.request.use(
  (config) => {
    // Don't override if custom token is already set in headers
    if (!config.headers.Authorization) {
      const token = getAdminToken();
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }

    if (config.data instanceof FormData) {
      config.headers["Content-Type"] = "multipart/form-data";
    } else {
      config.headers["Content-Type"] = "application/json";
    }
    
    // CRITICAL FIX: Remove body for DELETE requests when no data is needed
    if (config.method === 'delete' && (!config.data || config.data === null || config.data === undefined)) {
      delete config.data;
    }
    
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor — handle expired token (401) from backend
invoiceAxiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      sessionStorage.clear();
      window.location.replace('/admin/login');
    }
    return Promise.reject(error);
  }
);

// only admin
function getAdminToken() {
  return auth("admin")?.token
    || auth("hr")?.token
    || auth("salesperson")?.token
}

// FIXED INVOICE_APICALL - The key fix is here
export const INVOICE_APICALL = async (endPoint = '', method = "GET", value = null, customToken = null) => {
  try {
    const config = {
      method: method,
      url: endPoint,
    };
    
    // CRITICAL FIX: Handle DELETE requests differently
    const methodUpper = method.toUpperCase();
    
    if (methodUpper === 'DELETE') {
      // For DELETE requests, NEVER send a body with null/undefined
      // Only send data if it's a real object with properties
      if (value && typeof value === 'object' && Object.keys(value).length > 0) {
        config.data = value;
      }
      // Otherwise, don't include data at all - this prevents "null" from being sent
    } else {
      // For non-DELETE methods, send data if it exists
      if (value !== null && value !== undefined) {
        config.data = value;
      }
    }

    // If custom token provided, add it to headers
    if (customToken) {
      config.headers = {
        'Authorization': `Bearer ${customToken}`,
        'Content-Type': 'application/json'
      };
    }

    const response = await invoiceAxiosInstance(config);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};